import { YStack, XStack, Text, View } from "tamagui";
import { RiArrowLeftSLine } from "react-icons/ri";
import Header from "@components/layout/Header";
import RadiusContentWrapper from "@components/layout/RadiusContentWrapper";
import Steper from "@screen/Register/components/Steper";
import { colors } from "@styles/colors";

interface StepLayoutProps {
  title: string;
  subtitle?: string;
  onBack?: () => void;
  /** 1-based 目前步驟；省略則不顯示步驟點。 */
  step?: number;
  totalSteps?: number;
  children: React.ReactNode;
  /** 底部固定按鈕區。 */
  footer?: React.ReactNode;
}

/**
 * 新用戶流程共用版面：藍色 Header（返回／標題／副標／步驟點）+ 可捲動內容 + 固定底部。
 * 對齊既有 joinByInvite / Register 版面（Header + RadiusContentWrapper）。
 */
const StepLayout = ({ title, subtitle, onBack, step, totalSteps = 4, children, footer }: StepLayoutProps) => {
  return (
    <YStack height="100dvh" width="100vw" background={colors.bg}>
      <Header>
        {onBack && (
          <XStack ai="center" onPress={onBack} cursor="pointer" mb="$2">
            <View mr="$1">
              <RiArrowLeftSLine size={20} color={colors.light} />
            </View>
            <Text color="rgba(255,255,255,0.75)" fontSize={13}>
              返回
            </Text>
          </XStack>
        )}
        <Text color={colors.light} fontSize={22} fontWeight="800">
          {title}
        </Text>
        {subtitle && (
          <Text color="rgba(255,255,255,0.75)" fontSize={13} mt="$1">
            {subtitle}
          </Text>
        )}
        {step != null && (
          <View mt="$3">
            <Steper total={totalSteps} current={step} />
          </View>
        )}
      </Header>

      <RadiusContentWrapper>{children}</RadiusContentWrapper>

      {footer && (
        <YStack
          background={colors.light}
          borderTopWidth={1}
          borderTopColor={colors.borderLight}
          p="$3"
          style={{ paddingBottom: "max(12px, env(safe-area-inset-bottom))" }}>
          {footer}
        </YStack>
      )}
    </YStack>
  );
};

export default StepLayout;
